import React from 'react';

/**
 * Reusable Empty State component
 */
const EmptyState = ({ 
  icon, 
  title, 
  description, 
  action 
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-8 sm:p-12">
      <div className="text-center max-w-md mx-auto">
        {/* Icon */}
        {icon && (
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            {typeof icon === 'string' ? (
              <span className="text-3xl">{icon}</span>
            ) : (
              icon
            )}
          </div>
        )}
        
        {/* Title */}
        {title && (
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {title}
          </h3>
        )}
        
        {/* Description */}
        {description && (
          <p className="text-sm text-gray-600 mb-6">
            {description}
          </p>
        )}
        
        {/* Action button (optional) */}
        {action && (
          <div className="mt-6">
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
